import { ErreurApi } from '../api/client';
import { useIgnorerEnvoi } from '../api/hooks';
import type { CommandeListee } from '../api/types';
import { useToasts } from './Toasts';

/**
 * « Ne pas prévenir le client » : l'étape est tenue pour faite, sans mail.
 *
 * Proposé dans la fenêtre même du mail, parce que c'est là qu'on décide : la
 * date a été annoncée au téléphone, le client passe chercher sa commande. Sans
 * ce bouton, la seule façon de faire taire la tâche était d'envoyer un mail
 * dont personne ne voulait.
 *
 * Absent quand le mail est déjà parti ou déjà écarté : il n'y a plus rien à
 * écarter.
 */
export function IgnorerMailClient({
  commande, canal, onFait, avant, desactive = false,
}: {
  commande: CommandeListee;
  canal: 'expedition' | 'tracking';
  onFait: () => void;
  /** Enregistre d'abord la saisie en cours ; `false` interrompt le geste. */
  avant?: () => Promise<boolean>;
  desactive?: boolean;
}) {
  const ignorer = useIgnorerEnvoi();
  const { ajouter } = useToasts();

  const etat = commande.envois[canal].etat;
  if (etat === 'envoye' || etat === 'ignore') return null;

  return (
    <button
      type="button" className="btn" disabled={desactive || ignorer.isPending}
      title="L’étape est tenue pour faite, sans mail au client. La commande passe à la suite."
      onClick={async () => {
        if (avant && !(await avant())) return;
        try {
          await ignorer.mutateAsync({ id: commande.id, canal });
          ajouter(`${commande.ref} : ${canal === 'tracking' ? 'tracking' : 'expédition'} sans mail au client, étape suivante.`);
          onFait();
        } catch (e) {
          ajouter(e instanceof ErreurApi ? e.message : 'L’étape n’a pas pu être ignorée.', 'bad');
        }
      }}
    >
      {ignorer.isPending ? <><span className="spin" /> …</> : 'Ignorer et passer à la suite'}
    </button>
  );
}
